namespace GeniuzPOS.Points {
    export interface MemberTypeRow {
        Id?: number;
        MemberType?: string;
        MemberTypeDesc?: string;
        MbPriceFg?: number;
        MbDiscPs?: number;
        SellUnitPriceNo?: number;
        CreateBy?: string;
        CreateDate?: string;
        UpdateBy?: string;
        LastUpdate?: string;
        DtList?: PrPointCampaignRow[];
    }

    export namespace MemberTypeRow {
        export const idProperty = 'MemberType';
        export const nameProperty = 'MemberType';
        export const localTextPrefix = 'Points.MemberType';
        export const lookupKey = 'Points.MemberType';

        export function getLookup(): Q.Lookup<MemberTypeRow> {
            return Q.getLookup<MemberTypeRow>('Points.MemberType');
        }
        export const deletePermission = '3Member:Points:เงื่อนไขการสะสมแต้ม:Delete';
        export const insertPermission = '3Member:Points:เงื่อนไขการสะสมแต้ม:Modify';
        export const readPermission = '3Member:Points:เงื่อนไขการสะสมแต้ม:View';
        export const updatePermission = '3Member:Points:เงื่อนไขการสะสมแต้ม:Modify';

        export declare const enum Fields {
            Id = "Id",
            MemberType = "MemberType",
            MemberTypeDesc = "MemberTypeDesc",
            MbPriceFg = "MbPriceFg",
            MbDiscPs = "MbDiscPs",
            SellUnitPriceNo = "SellUnitPriceNo",
            CreateBy = "CreateBy",
            CreateDate = "CreateDate",
            UpdateBy = "UpdateBy",
            LastUpdate = "LastUpdate",
            DtList = "DtList"
        }
    }
}
